import { API_ENDPOINTS } from "@utils/api/endpoints";

export default async function () {
  try {
    return await $apiFetch(API_ENDPOINTS.STOCK_CATEGORIES, {
      method: 'GET'
    });
  } catch (error) {
    sentryCaptureEvent({
      message: 'stock-categories-load',
      level: 'error',
      extra: { error }
    });
  }

  return null;
}
